export const ONE_MB = 1048576
